module.exports = __webpack_public_path__ + "img/desc5.375960e3.png";